import {
  FIREBASE_API_KEY,
  FIREBASE_AUTH_DOMAIN,
  FIREBASE_DATABASE_URL,
  FIREBASE_PROJECT_ID,
} from '@/utils/constants'
import { getApp, initializeApp } from 'firebase/app'
import 'firebase/auth'
import { getAuth } from 'firebase/auth'

const createFirebaseApp = () => {
  try {
    return getApp()
  } catch (_) {
    return initializeApp({
      apiKey: FIREBASE_API_KEY,
      authDomain: FIREBASE_AUTH_DOMAIN,
      databaseURL: FIREBASE_DATABASE_URL,
      projectId: FIREBASE_PROJECT_ID,
    })
  }
}

export const firebaseClientAuth = getAuth(createFirebaseApp())
